import { wrapper } from 'store';
import auth from 'utils/auth';

const Index = () => {
    return null;
};

export const getServerSideProps = wrapper.getServerSideProps(
    (store) =>
        async ({ req, res, query }) => {
            await auth(store, req, res);
            const state = store.getState().auth;
            if (state.isAuthenticated) {
                return {
                    redirect: {
                        destination: `/${state.company}${
                            query.showPremiumBanner == 1
                                ? `?showPremiumBanner=1`
                                : ''
                        }`,
                        permanent: false,
                    },
                };
            }
            return {
                redirect: {
                    destination: '/register',
                    permanent: false,
                },
            };
        }
);

export default wrapper.withRedux(Index);
